import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
  const services = [
    {
      id: 'driveway-washing',
      title: 'Driveway Washing',
      description: 'Professional pressure washing services that restore your driveway to like-new condition, removing oil stains, dirt, and years of buildup.',
      image: 'https://media.istockphoto.com/id/1306260790/photo/man-cleaning-red-conrete-pavement-block-using-high-pressure-water-cleaner-paving-cleaning.jpg?s=612x612&w=0&k=20&c=h_c6WeiBkXSWDwas81aJE6_ej80Pyh9SrGQIwzAsgRI=',
      link: '/services/driveway-washing'
    },
    {
      id: 'patio-cleaning',
      title: 'Patio Cleaning',
      description: 'Professional patio cleaning service removes dirt, grime, algae & stains. Restore your outdoor space\'s beauty with our pressure washing expertise.',
      image: 'https://media.istockphoto.com/id/1335018444/photo/cleaning-stone-slabs-on-patio-with-the-high-pressure-cleaner.jpg?s=612x612&w=0&k=20&c=OgCpzV5P1-2npEnQTwUwRGA9bm2Z0ISeSIQlkHAKSt0=',
      link: '/services/patio-cleaning'
    },
    {
      id: 'gutter-cleaning',
      title: 'Gutter Cleaning',
      description: 'Complete debris removal, downspout clearing, and system inspection to protect your home from water damage.',
      image: 'https://media.istockphoto.com/id/1425320942/photo/cleaning-the-gutter-from-autumn-leaves-before-winter-season-roof-gutter-cleaning-process.webp?a=1&b=1&s=612x612&w=0&k=20&c=n8KYfMjTjoexNx8_8BHl4u1TAVMfa_9Qfc7MmrF2-mI=',
      link: '/services/gutter-cleaning'
    },
    {
      id: 'roof-cleaning',
      title: 'Roof Cleaning',
      description: 'Expert soft-wash roof cleaning that removes algae, moss, and stains safely without damaging your roofing materials.',
      image: './../../public/images/roof.jpg',
      link: '/services/roof-cleaning'
    },
    {
      id: 'solar-panel-cleaning',
      title: 'Solar Panel Cleaning',
      description: 'Professional solar panel cleaning to maximize energy efficiency with gentle, effective cleaning methods.',
      image: 'https://media.istockphoto.com/id/492025689/photo/cleaning-moduls-electricity.jpg?s=612x612&w=0&k=20&c=RI_o-h01xJtlYFoyAZVVaqqCOcoJOPcowjfv99cZwsA=',
      link: '/services/solar-panel-cleaning'
    },
    {
      id: 'residential-cleaning',
      title: 'Residential & Commercial Cleaning',
      description: 'Professional Residential amd Commerical cleaning to maximize regular domestic cleaning to deep sanitation services.',
      image: 'https://media.istockphoto.com/id/2194521638/photo/cleaning-cart-with-detergents-cleaning-mop-bucket-and-vacuum-cleaner-in-empty-hotel-corridor.jpg?s=612x612&w=0&k=20&c=2DL1k7hYr2A4N0Zrxbg0KgyQs04ZLNhzSpTeGHIxwmk=',
      link: '/services/residential-cleaning'
    }
  ];

  useEffect(() => {
    // Add hover animations to service images
    const serviceImages = document.querySelectorAll('.service-img');
    serviceImages.forEach(img => {
      const handleMouseOver = () => {
        img.style.transform = 'scale(1.05)';
      };
      
      const handleMouseOut = () => {
        img.style.transform = 'scale(1)';
      };

      img.addEventListener('mouseover', handleMouseOver);
      img.addEventListener('mouseout', handleMouseOut);

      // Cleanup
      return () => {
        img.removeEventListener('mouseover', handleMouseOver);
        img.removeEventListener('mouseout', handleMouseOut);
      };
    });
  }, []);

  return (
    <section className="services" id="services">
      <div className="services-header">
        <h2>Our Services</h2>
        <p>We offer comprehensive exterior cleaning solutions tailored to your needs.</p>
      </div>

      {services.map((service) => (
        <div key={service.id} className="service-poster animate-on-scroll" id={service.id}>
          <div 
            className="service-img" 
            style={{ backgroundImage: `url('${service.image}')` }}
          ></div>
          <div className="service-content">
            <h3>{service.title}</h3>
            <p>{service.description}</p>
            <Link to={service.link} className="service-link">
              Learn More →
            </Link>
          </div>
        </div>
      ))}
    </section>
  );
};

export default Services;
// /**
//  * Services Component
//  * Renders the services section with cards
//  * The main services of Clean Knight including roof, driveway, patio, gutter and solar panel cleanjng
//  */

// const Services = {
//   // Services data - could be moved to a separate data file for larger projects
//   services: [
//     {
//       id: 'driveway-washing1',
//       title: 'Driveway Washing',
//       description: 'Our high-quality pressure washing service removes dirt, grime, and stains from driveways, sidewalks, and other hard surfaces around your property.',
//       image: 'https://media.istockphoto.com/id/1306260790/photo/man-cleaning-red-conrete-pavement-block-using-high-pressure-water-cleaner-paving-cleaning.jpg?s=612x612&w=0&k=20&c=h_c6WeiBkXSWDwas81aJE6_ej80Pyh9SrGQIwzAsgRI='
//     },
//     {
//       id: 'patio-cleaning1',
//       title: 'Patio Cleaning',
//       description: 'Professional patio cleaning service removes dirt, grime, algae & stains. Restore your outdoor space\'s beauty with our pressure washing expertise.',
//       image: 'https://media.istockphoto.com/id/1335018444/photo/cleaning-stone-slabs-on-patio-with-the-high-pressure-cleaner.jpg?s=612x612&w=0&k=20&c=OgCpzV5P1-2npEnQTwUwRGA9bm2Z0ISeSIQlkHAKSt0='
//     },
//     {
//       id: 'gutter-cleaning1',
//       title: 'Gutter Cleaning',
//       description: 'Clogged gutters can cause water damage to your home. Our gutter cleaning service removes debris and ensures proper water flow away from your property.',
//       image: 'https://media.istockphoto.com/id/1425320942/photo/cleaning-the-gutter-from-autumn-leaves-before-winter-season-roof-gutter-cleaning-process.webp?a=1&b=1&s=612x612&w=0&k=20&c=n8KYfMjTjoexNx8_8BHl4u1TAVMfa_9Qfc7MmrF2-mI='
//     },
//     {
//       id: 'roof-cleaning1',
//       title: 'Roof Cleaning',
//       description: 'Remove moss, algae, and debris from your roof to extend its lifespan and improve your home\'s curb appeal with our gentle but effective roof cleaning service.',
//       image: 'https://media.istockphoto.com/id/490080148/photo/roof-cleaning-with-high-pressure.webp?a=1&b=1&s=612x612&w=0&k=20&c=0EzOO2zR2VUAWt02uT78D6c6q5Glg9bPmZNsQt73F34='
//     }
//     ,
//     {
//       id: 'solar-cleaning1',
//       title: 'Solar Panel Cleaning',
//       description: 'Expert solar panel cleaning maximizes your energy savings. We safely remove dirt & debris that reduces efficiency. Residential & commercial.',
//       image: 'https://media.istockphoto.com/id/492025689/photo/cleaning-moduls-electricity.jpg?s=612x612&w=0&k=20&c=RI_o-h01xJtlYFoyAZVVaqqCOcoJOPcowjfv99cZwsA='
//     }
//   ],

//   render: () => {
//     // Create service cards HTML from the services array
//     const serviceCards = Services.services.map(service => `
//       <div class="service-card" id="${service.id}">
//         <div class="service-img" style="background-image: url('${service.image}');"></div>
//         <div class="service-content">
//           <h3>${service.title}</h3>
//           <p>${service.description}</p>
//         </div>
//       </div>
//     `).join('');

//     return `
//       <section class="services" id="services">
//         <div class="services-header">
//           <h2>Our Services</h2>
//           <p>We offer comprehensive exterior cleaning solutions tailored to your needs.</p>
//         </div>
//         ${serviceCards}
//       </section>
//     `;
//   },

//   setup: () => {
//     // Add hover animations to service images
//     const serviceImages = document.querySelectorAll('.service-img');
//     serviceImages.forEach(img => {
//       img.addEventListener('mouseover', () => {
//         img.style.transform = 'scale(1.05)';
//       });
      
//       img.addEventListener('mouseout', () => {
//         img.style.transform = 'scale(1)';
//       });
//     });
//   }
// };

// export default Services;